import { View, Grid, useTheme, Card, } from "@aws-amplify/ui-react";
import GaugeMeter from '../../../components/gaugemeter/GaugeMeter';
import ModelPerformanceTable from '../../../components/modelperformancetable/ModelPerformanceTable';
import React from 'react';
import MultipleBarChart from '../../../components/Charts/MultiplebarChart';
import MultipleBarChart2 from '../../..//components/Charts/MultiplebarChart2';

const Slot = () => {
    const { tokens } = useTheme();
    return (
        <>
     
            <View borderRadius="5px" maxWidth="100%" width={'100%'} padding="0rem" minHeight="100vh" >
            <View className="emoji"
            as="div"
            backgroundColor="var(--amplify-colors-white)"
            borderRadius="15px"
            border="1px solid #e9e9e9"
            color="#242424"
            height="2.6rem"
            maxWidth="100%"
            padding="0.5rem"
            fontSize={14}
            fontWeight={400}
            width="10rem"
            textAlign={'center'}
            // onClick={() => alert('')}
            >
            {"🤗  Hugging Face"}
            </View>

            <Grid width={'100%'}
                    templateColumns={{ base: "1fr", large: "1fr 1fr" }}
                    gap={tokens.space.xl}
                >

                    <View columnSpan={[1, 1, 3]} rowSpan={{ base: 3, large: 4 }}>
                        <Grid templateColumns={{ base: "1fr", large: "1fr 2fr" }} gap={tokens.space.xl}>
                            <View rowSpan={{ base: 1, large: 1 }}>
                                <Card className="aipresettask">
                                    <h4 className="mb-4">Model Performance</h4>
                                    <GaugeMeter />
                                </Card>
                            </View>
                            <View rowSpan={{ base: 1, large: 1 }}>
                                <ModelPerformanceTable />
                            </View>
                        </Grid>
                    </View>
                </Grid>
                <Grid
                    className="mt-30"
                    templateColumns={{ large: "1fr 1fr", base: "1fr 1fr", medium: "1fr", small: '1fr' }}
                    templateRows={{ base: "repeat(2, auto)", large: "repeat(2, auto)" }}
                    gap={tokens.space.xl}
                >
                    <View columnSpan={[1, 1]} >
                        <Card className="aipresettask" style={{ width: 'auto' }}>
                            <h4 className="mb-4">Tagging Metrics</h4>
                            <div className="chart-container">
                                <MultipleBarChart2 />
                            </div>
                        </Card>
                    </View>
                    <View columnSpan={[1, 1]}>
                        <Card className="aipresettask" style={{ width: 'auto' }}>
                            <h4 className="mb-4">Distribution of tags in the train Dataset</h4>
                            <div className="chart-container" >
                                <MultipleBarChart />
                            </div>
                        </Card>
                    </View>
                </Grid>
            </View >



        </>
    )
}

export default Slot